import http from '../common/http-auth'

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const getAllSuppressionListByClientId = async (clientId: number) => {
    const response = http.get(`/suppressionlist/all?clientId=${clientId}`);
    return response;
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any
export const addSuppressionList = async (data: any) => {
    const response = http.post(`/suppressionlist/add`, data)
    return response;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any
export const deleteList= async (listId: any, modifiedById: any) => {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/restrict-template-expressions
    const response = http.delete(`/suppressionlist/delete?suppressionListId=${listId}&modifiedBy=${modifiedById}`)
    return response;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const getSuppressionListById = async (id?: number) => {
    const response = http.get(`/suppressionlist/${id !== undefined ? id : ''}`)
    return response;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any
export const updateSuppressionList = async (data: any) => {
    const response = http.put(`/suppressionlist/update`, data)
    return response;
}